import App from './pages/App.js'

new App()
